module.exports = require("@ember/template-factory");